import { render, staticRenderFns } from "./AutoCheckScrapped.vue?vue&type=template&id=588cace5&"
import script from "./AutoCheckScrapped.vue?vue&type=script&lang=js&"
export * from "./AutoCheckScrapped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports